<template>
  <div v-if="data_ecole[0]" style="padding:2em;">
    <div v-if="isLoading" class="loading">Loading&#8230;</div> 




<div class="columns">

<div class="column is-8">
<div class="columns box is-gapless is-multiline"> 

  <div class="column is-2 isLabel has-background-light">Code *</div>  
  <div class="column is-8 isLabel has-background-light">School Name *</div>
  <div class="column is-2 isLabel has-background-light">Abbrv. *</div>

 <div @keyup="set_mod()" class="column is-2"><input v-model="data_ecole[0].school_CODE" placeholder="Code" class="input has-text-left is-fullwidth">  </div>

  <div @keyup="set_mod()" class="column is-8"><input v-model="data_ecole[0].school_NAME" placeholder="Nom" class="input has-text-left is-fullwidth">  </div>
  <div @keyup="set_mod()" class="column is-2"><input v-model="data_ecole[0].school_NICKNAME" placeholder="Nom" class="input has-text-left is-fullwidth">  </div>
  
<div class="column is-12 has-background-light" style="margin-top:1em;"></div>

<div class="column is-10 isLabel has-background-light">Address</div>
<div class="column is-2 isLabel has-background-light">Burreau</div>



  <div @keyup="set_mod()" class="column is-10">
    <div class="control has-icons-left has-icons-right">
    <span class="icon is-left"><i class="fas fa-map-marker-alt fa-lg"></i></span>
        <vue-google-autocomplete
        v-model="address_holder"
            ref="Address"
            id="map"
            classname="input is-fullwidth has-text-weight-bold"
            placeholder="adresse"
            v-on:placechanged="getAddressData"
            country="ca">
        </vue-google-autocomplete> 
    </div>  
  </div>
 <div @keyup="set_mod()" class="column is-2"><input v-model="data_ecole[0].school_BUR" placeholder="Nom" class="input has-text-left is-fullwidth">  </div>

<div class="column is-12 has-background-light" style="margin-top:1em;"></div>

  <div class="column is-3 isLabel has-background-light">Phone</div>
  <div class="column is-5 isLabel has-background-light">Email</div>
  <div class="column is-4 isLabel has-background-light">Website</div>


  <div @keyup="set_mod()" class="column is-3"><input v-model="data_ecole[0].school_TELEPHONE" v-mask="'(###) ###-####'" placeholder="Phone" class="input has-text-left is-fullwidth">  </div>
  <div @keyup="set_mod()" class="column is-5"><input v-model="data_ecole[0].school_EMAIL" placeholder="Email" class="input has-text-left is-fullwidth">  </div>
  <div @keyup="set_mod()" class="column is-4"><input v-model="data_ecole[0].school_WEBSITE" placeholder="Web" class="input has-text-left is-fullwidth">  </div>




    



</div>
</div>
<!-- END 4 -->


  <!-- <div class="column is-12"> TRAN CODES </div>
  <div class="column is-12 has-text-white"> --  </div>
  <div class="column is-3 is-size-7 has-text-weight-bold">FR</div>
  <div @keyup="changed_tran = true" class="column is-9"><input v-model="data_ecole[0].school_TranCODE" v-mask="'######'" class="input has-text-left is-fullwidth">  </div>
  <div class="column is-3 is-size-7 has-text-weight-bold">AN</div>
  <div @keyup="changed_tran = true" class="column is-9"><input v-model="data_ecole[0].school_TranCODE_ENGLISH" v-mask="'######'" class="input has-text-left is-fullwidth">  </div>
  <div v-if="changed_tran" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
    <button @click="save_tran()" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
  </div> -->


<!-- END 4 -->

 
<div class="column has-text-centered is-4">
<div class="columns is-vcentered is-gapless is-multiline"> 

 <!-- ECOLE SAVE  -->
  <div v-if="changed_ecole" class="column has-text-centered is-12 has-text-weight-bold is-size-6"> 
    <button @click="save_ecole()" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
  </div>




<div class="column is-12 isLink" onclick="document.getElementById('selectFile').click();">
    <input id="selectFile" type="file" style="display: none;" @change="item_image" accept="image/*">
    <figure class="image is-5by4"> <img :src="return_logo()" alt="logo"></figure>
</div>
</div>

</div>
<!-- END 4 -->


</div>


<!-- TRAN INFO AND THE LIKES ....  -->
<div class="columns box has-background-link-light" style="margin-top:-4em;">
<div class="column is-6">
  <div class="columns is-gapless is-multiline">
      <div class="column is-2 mt-2 isLabel">KEY PUB.</div><div class="column is-10"> <input   @keyup="set_mod()" class="input is-fullwidth is-info" v-model="data_ecole[0].encrypt_PubRing" type="text" placeholder="...."></div>
      <div class="column is-2 mt-2 isLabel">KEY PRIV.</div><div class="column is-10"> <input   @keyup="set_mod()" class="input is-fullwidth is-info" v-model="data_ecole[0].encrypt_PrivRing" type="text" placeholder="...."></div>
      <div class="column is-2 mt-2 isLabel">ENC. ID</div><div class="column is-4"><input   @keyup="set_mod()" class="input is-fullwidth is-info" v-model="data_ecole[0].encrypt_SchoolID" type="text" placeholder="...."></div>
      <div class="column is-2 mt-2 isLabel">&nbsp;&nbsp;&nbsp;&nbsp;PHRASE</div><div   @keyup="set_mod()" class="column is-4"><input  class="input is-fullwidth is-info" v-model="data_ecole[0].encrypt_PassPhrase" type="text" placeholder="...."></div>
  </div> 
</div>

<div class="column is-6">
  <div class="columns is-gapless is-multiline">
      <div class="column is-2 mt-2 isLabel">FTP USER</div><div class="column is-4"><input   @keyup="set_mod()" class="input is-fullwidth is-info" v-model="data_ecole[0].ftp_UserName" type="text" placeholder="...."></div>
      <div class="column is-2 mt-2 isLabel">&nbsp;&nbsp;&nbsp;&nbsp;FTP PASS</div><div  @keyup="set_mod()" class="column is-4"><input  class="input is-fullwidth is-info" v-model="data_ecole[0].ftp_Password" type="text" placeholder="...."></div>
      <div class="column is-2 mt-2 isLabel">FTP PATH</div><div class="column is-10"> <input   @keyup="set_mod()" class="input is-fullwidth is-info" v-model="data_ecole[0].ftp_RemoteDirectory" type="text" placeholder="...."></div>

      <div class="column is-4 mt-2 isLabel has-text-centered">BULLETIN NAME</div><div  @keyup="set_mod()" class="column is-8"> <input  class="input is-fullwidth is-info" v-model="data_ecole[0].bulliten_NAME" type="text" placeholder="...."></div>



  </div> 
</div>



</div>
<!-- **END** TRAN INFO AND THE LIKES ....  -->





  </div>
</template>

<script>
import axios from 'axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'AdminContact',
  props: [ ],
  components: { VueGoogleAutocomplete },

    data() {
        return {
            isLoading:false,

data_ecole:[],

            changed_ecole:false,
            changed_tran:false,

address_holder: '',
            address: '',
            place: '',

        }
    },




created() {
  this.ecole_get()
},





methods: {

set_mod:function(){
  this.changed_ecole = true;
  this.$emit('emit_school_change', true) 
},


ecole_get:function(){
// GET SCHOOL INFO  
  this.isLoading = true;
  var query = "SELECT * FROM MyMEQ_SCHOOLINFO"
  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
  .then(res => { 
      this.data_ecole = res.data
      this.address_holder = this.data_ecole[0].school_ADDRESS + " " + this.data_ecole[0].school_CITY + " " + this.data_ecole[0].school_POSTAL 
      this.isLoading = false;
  });
},



save_ecole:function() {

var sqlAddress = ''
if (this.address) {

    sqlAddress += ", school_ADDRESS = '" + this.chk_string(this.address.street_number) + " " + this.chk_string(this.address.route) + "'," ; this.data_ecole[0].school_ADDRESS = this.address.street_number + " " + this.address.route 
    sqlAddress += "school_CITY = '" + this.chk_string(this.address.locality) + "'," ; this.data_ecole[0].school_CITY = this.address.locality
    sqlAddress += "school_PROVINCE = '" + this.chk_string(this.address.administrative_area_level_1) + "'," ; this.data_ecole[0].school_PROVINCE = this.address.administrative_area_level_1
    sqlAddress += "school_COUNTRY = '" + this.chk_string(this.address.country) + "'," ; this.data_ecole[0].school_COUNTRY = this.address.country
    sqlAddress += "school_POSTAL = '" + this.chk_string(this.address.postal_code) + "' " ; this.data_ecole[0].school_POSTAL = this.address.postal_code
}


var query = "UPDATE MyMEQ_SCHOOLINFO SET school_NAME = '" + this.chk_string(this.data_ecole[0].school_NAME) + "' "
query += ", school_CODE = '" + this.chk_string(this.data_ecole[0].school_CODE) + "' "
query += ", school_NICKNAME = '" + this.chk_string(this.data_ecole[0].school_NICKNAME) + "' "
query += ", school_TELEPHONE = '" + this.chk_string(this.data_ecole[0].school_TELEPHONE) + "' "
query += ", school_EMAIL = '" + this.chk_string(this.data_ecole[0].school_EMAIL) + "' "
query += ", school_WEBSITE = '" + this.chk_string(this.data_ecole[0].school_WEBSITE) + "' "
query += ", school_BUR = '" + this.chk_string(this.data_ecole[0].school_BUR) + "' "

query += ", encrypt_PubRing = '" + this.data_ecole[0].encrypt_PubRing + "' "
query += ", encrypt_PrivRing = '" + this.data_ecole[0].encrypt_PrivRing + "' "
query += ", encrypt_SchoolID = '" + this.data_ecole[0].encrypt_SchoolID + "' "
query += ", encrypt_PassPhrase = '" + this.data_ecole[0].encrypt_PassPhrase + "' "
query += ", ftp_UserName = '" + this.data_ecole[0].ftp_UserName + "' "
query += ", ftp_Password = '" + this.data_ecole[0].ftp_Password + "' "
query += ", ftp_RemoteDirectory = '" + this.data_ecole[0].ftp_RemoteDirectory + "' "
query += ", bulliten_NAME = '" + this.data_ecole[0].bulliten_NAME + "' "

query += sqlAddress
query += " WHERE school_CODE = '" + sessionStorage.getItem('college_code') + "'"


console.log(query)


axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
        this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
        this.changed_ecole = false 
        this.$emit('emit_school_change', false) 
});




},
save_tran:function() {

},

return_logo:function(pic) {
    return sessionStorage.getItem('logo')
},

item_image:function(event) {
  this.imageChanged = true;
  this.$emit('mod_emit');
  var input = event.target;
  if (input.files && input.files[0]) { 

console.log(input.files[0].name)

const formData = new FormData();
let file = input.files[0];
formData.append('files', file);
axios.post(this.$url+'/upload_image',formData) 
.then(res => {
    var sql = "UPDATE MyMEQ_SCHOOLINFO SET school_logo = '" + input.files[0].name + "'"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
        this.data_ecole[0].school_logo = input.files[0].name
    })
})
}

}, // END IMAGE SORT


check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},

chk_string:function(val){
    // CHECK FOR BLANC STRING --
    try {return val.replace(/'/g,"''")}
    catch(err) {return ''}
},


    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData) {
        this.address = addressData;
        this.place = placeResultData
    },

} // END METHODS

}
</script>


<style scoped>

</style>
